"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testNoPower = exports.useSystem = exports.findSystem = exports.init = exports.createSystemState = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageSystemsData_sidecar_1 = require("@voyage/systems/voyageSystemsData-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var voyageTilemapPart_sidecar_1 = require("@voyage/tilemap/voyageTilemapPart-sidecar");
var createSystemState = function (tile, key, id) {
    var data = voyageSystemsData_sidecar_1.voyageSystemsData.find(tile);
    tile.system = {
        key: key,
        requestedInfo: false,
        ammo: 0,
        nickname: '',
        frozenCrewName: '',
        data: data,
        id: id,
    };
};
exports.createSystemState = createSystemState;
var init = function (tile, key, id) {
    // console.log('init system')
    exports.createSystemState(tile, key, id);
    assert_sidecar_1.assert.notNil(tile.system);
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        // tile.system.nickname = voyageFakeInfo.genFakeProjectName()
    }
    tile.system.ammo = tile.system.data.startsWithAmmo;
    if (tile.system.data.onCreate) {
        tile.system.data.onCreate(tile.system, tile.text3, tile);
    }
    var sys = tile.system;
    // console.log('got a system!', c.system.nickname)
    // console.log('sys init', key, id)
    if (sys.data.abbv && tile.text) {
        stevieTexts2_sidecar_1.stevieTexts2.setText(tile.text, sys.data.abbv);
        if (sys.data.abbv.length === 1) {
            stevieTexts2_sidecar_1.stevieTexts2.moveTo(tile.text, tile.x + 2 + sys.data.abbvXAdjust, tile.y + 2);
        }
        if (sys.data.abbv.length === 2) {
            stevieTexts2_sidecar_1.stevieTexts2.moveTo(tile.text, tile.x - 6 + sys.data.abbvXAdjust, tile.y + 2);
        }
    }
    if (sys.data.killImage) {
        if (tile.image3) {
            tile.image3.destroy(); //= false
            tile.image3 = null;
        }
    }
    if (sys.data.frame) {
        if (tile.text) {
            stevieTexts2_sidecar_1.stevieTexts2.setText(tile.text, '');
        }
        voyageTilemapPart_sidecar_1.voyageTilemapPart.setSystemImage(tile, sys.data.frame, sys.data.tint);
    }
};
exports.init = init;
function findSystem(name) {
    return voyageTilemap_sidecar_1.voyageTilemap.getSystemByKey(name);
}
exports.findSystem = findSystem;
function useSystem(obj, tCur) {
    if (tCur.system) {
        if (!obj.isPassedOut) {
            //} || tCur.system.data.canUseWhilePassedOut) {
            tCur.system.data.crewUpdate(obj);
        }
    }
}
exports.useSystem = useSystem;
var phrases = [
    'No power',
    'Not responding',
    'Agh!',
    'Stupid machine',
    'Someone fix the reactor',
];
function testNoPower(obj) {
    var status = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    if (status.power > 5) {
        return false;
    }
    if (rando_sidecar_1.rando.chance(0.25)) {
        diveCrew_sidecar_1.diveCrew.say(obj, rando_sidecar_1.rando.sample(phrases));
    }
    return true;
}
exports.testNoPower = testNoPower;
